import { ERoutes } from "../../config/enums.js";

export const SERVICE_PAGE_SECTION_VALUES = {
    TECHNOLOGY_ECOMMERCE: "technology-ecommerce",
    CREATIVE_DESIGN: "creative-design",
    MARKETING_GROWTH: "marketing-growth",
};

export const SERVICE_PAGE_SECTIONS = [
    {
        value: SERVICE_PAGE_SECTION_VALUES.TECHNOLOGY_ECOMMERCE,
        label: "Technology + Engineering",
        href: `${ERoutes.Services}#Technology+Engineering`,
        legacyAnchorIds: ["Technology+Ecommerce"],
    },
    {
        value: SERVICE_PAGE_SECTION_VALUES.CREATIVE_DESIGN,
        label: "Creative + Experience",
        href: `${ERoutes.Services}#Creative+Experience`,
        legacyAnchorIds: ["Creative+Design"],
    },
    {
        value: SERVICE_PAGE_SECTION_VALUES.MARKETING_GROWTH,
        label: "Marketing + Performance",
        href: `${ERoutes.Services}#Marketing+Performance`,
        legacyAnchorIds: ["Marketing+Growth"],
    },
];

export const SERVICE_PAGE_SECTION_OPTIONS = SERVICE_PAGE_SECTIONS.map(({ value, label }) => ({
    value,
    label,
}));

const SERVICE_PAGE_SECTION_BY_VALUE = new Map(
    SERVICE_PAGE_SECTIONS.map((section) => [section.value, section]),
);

const SERVICE_PAGE_SECTION_VALUE_BY_LEGACY_HEADING = new Map([
    ["Technology + Ecommerce", SERVICE_PAGE_SECTION_VALUES.TECHNOLOGY_ECOMMERCE],
    ["Creative + Design", SERVICE_PAGE_SECTION_VALUES.CREATIVE_DESIGN],
    ["Marketing + Growth", SERVICE_PAGE_SECTION_VALUES.MARKETING_GROWTH],
]);

const SERVICE_PAGE_SECTION_BY_HEADING = new Map(
    SERVICE_PAGE_SECTIONS.map((section) => [section.label, section]),
);

for (const [heading, value] of SERVICE_PAGE_SECTION_VALUE_BY_LEGACY_HEADING) {
    const section = SERVICE_PAGE_SECTION_BY_VALUE.get(value);

    if (section) {
        SERVICE_PAGE_SECTION_BY_HEADING.set(heading, section);
    }
}

/**
 * @param {string | null | undefined} value
 * @returns {(typeof SERVICE_PAGE_SECTIONS)[number] | undefined}
 */
export function getServicePageSection(value) {
    if (!value) return undefined;

    return SERVICE_PAGE_SECTION_BY_VALUE.get(value);
}

/**
 * @param {string} heading
 * @returns {{ canonical: string, aliases: string[] }}
 */
export function getServiceSectionAnchorIds(heading) {
    const section = SERVICE_PAGE_SECTION_BY_HEADING.get(heading);

    if (!section) {
        return {
            canonical: heading.replace(/\s/g, ""),
            aliases: [],
        };
    }

    return {
        canonical: section.href.split("#")[1],
        aliases: [...section.legacyAnchorIds],
    };
}
